import React from 'react';
import { cn } from '@components/lib/utils';
import { ProfileRoundedTab } from '../ProfileRoundedTab';
import { ICON_NAME_MAP, Tab } from './types';

interface FixedTabsProps {
  tabs: Tab[];
  tempValue: number;
  value: number;
  setFade: (value: boolean) => void;
  setTempValue: (value: number) => void;
  setValue: (value: number) => void;
  colorMode: string;
  isOnboarding: boolean;
  isLoggedIn?: boolean;
  isPreview?: boolean;
}

const FixedTabs: React.FC<FixedTabsProps> = ({
  tabs,
  tempValue,
  value,
  setFade,
  setTempValue,
  setValue,
  colorMode,
  isOnboarding,
  isLoggedIn,
  isPreview,
}) => {
  const handleTabClick = (index: number) => {
    value !== index && setFade(true);

    setTempValue(index);
    setTimeout(() => setValue(index), 600);
  };

  const isFullWidth = isPreview || isOnboarding || !isLoggedIn;

  return (
    <div
      id="fixed-tabs-container"
      className={cn(
        '[&&&]:hidden [&&&]:fixed [&&&]:top-0 [&&&]:bottom-auto [&&&]:z-10',
        '[&&&]:items-start [&&&]:justify-center',
        '[&&&]:max-[743px]:left-0 [&&&]:max-[743px]:w-full',
        '[&&&]:max-[743px]:max-w-screen [&&&]:max-[743px]:p-[10px]',
        '[&&_>_div]:w-full',
        isFullWidth
          ? '[&&&]:left-0 [&&&]:w-full'
          : '[&&&]:left-[288px] [&&&]:w-[calc(100%-288px)]',
        'bottom-button-wrapper',
        colorMode,
      )}
    >
      <div className="flex w-full max-w-[540px]">
        <div className="relative flex w-auto list-none overflow-hidden overflow-x-scroll p-0 [scrollbar-width:none] [&&&_button:last-child]:mr-0 [&&&_button]:mr-[10px] [&&&_button]:w-[50px] [&&&_button]:bg-transparent [&&&_button]:shadow-none [&::-webkit-scrollbar]:hidden">
          {tabs.map(({ type, source }, index) => (
            <ProfileRoundedTab
              key={index}
              index={index}
              activeInd={tempValue}
              className={cn(
                'cursor-pointer',
                tempValue === index ? 'selected' : '',
              )}
              onClick={() => handleTabClick(index)}
              active={tempValue === index}
              IconType={
                source
                  ? source?.toLowerCase()?.capitalize()
                  : ICON_NAME_MAP[type]
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FixedTabs;
